import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import DesktopSidebar from "./sidebar/DesktopSidebar";
import MobileSidebar from "./sidebar/MobileSidebar";

const Sidebar = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    if (saved !== null) setCollapsed(saved === "true");
  }, []);

  return isSmallScreen ? (
    <MobileSidebar />
  ) : (
    <DesktopSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
  );
};

export default Sidebar;